var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90714 30.6526H18.35C18.8558 30.6526 19.3409 30.4517 19.6986 30.094C20.0562 29.7364 20.2571 29.2513 20.2571 28.7455V25.8848H18.35V28.7455H6.90714V5.85978H18.35V8.72049H20.2571V5.85978C20.2571 5.35397 20.0562 4.86888 19.6986 4.51123C19.3409 4.15357 18.8558 3.95264 18.35 3.95264H6.90714C6.40134 3.95264 5.91625 4.15357 5.55859 4.51123C5.20093 4.86888 5 5.35397 5 5.85978V28.7455C5 29.2513 5.20093 29.7364 5.55859 30.094C5.91625 30.4517 6.40134 30.6526 6.90714 30.6526Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8152 21.6757L24.2347 18.2562H10.7207V16.349H24.2347L20.8152 12.9295L22.1636 11.5812L27.885 17.3026L22.1636 23.024L20.8152 21.6757Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.61cdab0d800644faf262937760c9ac6e.svg";
export { ForwardRef as ReactComponent };